import React from "react";

/* ── Image imports ── */
import HeroBgImg from "../../../asset/images/our-team/hero-bg.webp";
import BcSepIcon from "../../../asset/images/about/breadcrumb-separator.svg";
import Img1 from "../../../asset/images/our-team/ravin.webp";
import Img2 from "../../../asset/images/our-team/swanand.webp";
import Img3 from "../../../asset/images/our-team/parameswary.webp";
import Img4 from "../../../asset/images/our-team/nirup.webp";
import Img5 from "../../../asset/images/our-team/nachiket.webp";
import Img6 from "../../../asset/images/our-team/rahul-s.webp";
import Img7 from "../../../asset/images/our-team/amiteer.webp";
import Img8 from "../../../asset/images/our-team/aditya.webp";
import Img9 from "../../../asset/images/our-team/shailesh.webp";
import Img10 from "../../../asset/images/our-team/anwar.webp";
import Img11 from "../../../asset/images/our-team/anwar.webp";

const TEAM = [
  {
    id: 1,
    firstName: "Ravin",
    lastName: "MIRCHANDANI",
    role: "Chairman",
    image: Img1,
    bio: "A seasoned traveler and distinguished business leader, Mr. Mirchandani is deeply committed to sustainable mobility and road safety. With a diverse background in international development, spanning energy, defense, telecom, and industrial gases, he is recognized for seamlessly integrating social responsibility with profitability. Mr. Mirchandani is renowned for his initiatives in lithium and hydrogen mobility, leveraging technology to influence driver behavior. Since 2018, he has served as a jury member for the CHARGE ENERGY awards, recognizing excellence in global energy, clean energy, and e-mobility. Holding a private pilot’s license, he emphasizes the alignment of work with passion as a catalyst for success.",
  },
  {
    id: 2,
    firstName: "Swanand",
    lastName: "DESHPANDE",
    role: "Executive Director & Chief Operating Officer",
    image: Img2,
    bio: "As the Executive Director and Chief Operating Officer, I bring a unique blend of strategic acumen and human-centered leadership to the table. With a foundation in people and talent management, my journey has been shaped by a deep commitment to building inclusive, mindful, and high-performing cultures. A lifelong student of neuroscience, yoga, and mindfulness, I believe that operational excellence and business success are amplified when people are empowered to thrive. I’m passionate about crafting environments where innovation flows, well-being matters, and purpose drives performance.",
  },
  {
    id: 3,
    firstName: "Ramaswamy",
    lastName: "L",
    role: "Head - Finance",
    image: Img3,
    bio: "A qualified Chartered Accountant & a senior Finance Professional with a strong commercial and legal acumen and has been associated with leading MNCs and Indian Companies in the Manufacturing Sector for over 25 years. Has managed and led the Finance, Accounts, Audit, Regulation, Costing, ERP, Systems & Processes, Legal, Secretarial and other functions in different capacities, including that of the CFO. He has been a key member of the core strategic group that takes major initiatives as well as critical business decisions. Occasionally, he has also been a guest lecturer at various leading institutions and has been involved in training sessions and teaching stints in the past.",
  },
  {
    id: 4,
    firstName: "Mriraj",
    lastName: "KUMAR",
    role: "Business Head - Clean Air",
    image: Img4,
    bio: "I’m an introvert hailing from a quaint countryside. Traveling and delving into different cultures and landscapes captivate me, as does my deep affinity for environmental preservation and cleaner air. Politics isn’t my cup of tea, but I’m eager to make meaningful contributions to society, particularly initiatives geared towards securing a sustainable future for our planet.",
  },
  {
    id: 5,
    firstName: "Nachiket",
    lastName: "KULKARNI",
    role: "Business Head - Traffic & Enforcement ( Products )",
    image: Img5,
    bio: "Nachiket, a dynamic cricketer turned adept project management and operations professional, continues to make an impact at Ador with his winning streak. As a certified Project Management Professional, his extensive experience spans diverse domains. Holding degrees in Mechanical Engineering and Engineering Management from Deakin University, Australia, Nachiket possesses exceptional business acumen. Renowned for flawlessly executing monumental projects, he currently spearheads Ador Powertron Ltd’s Traffic & Enforcement division as the Business Head, leading a team of 62. He seamlessly blends technical expertise with business acumen to achieve significant victories across all fronts",
  },
  {
    id: 6,
    firstName: "Rahul",
    lastName: "SAWARDEKAR",
    role: "Business Head - Traffic & Enforcement ( Projects )",
    image: Img6,
    bio: "Rahul is a seasoned business leader with a rich background in international development across diverse sectors like energy, defense, telecom, and industrial gases. As an experienced General Manager Operations, he boasts over 28 years of expertise in operations management, supply chain, and procurement within the electrical and electronic manufacturing industry. Currently seeking roles in Operations or Supply Chain management.",
  },
  {
    id: 7,
    firstName: "Abhijeet",
    lastName: "CHAUDHARI",
    role: "Head - R&D",
    image: Img7,
    bio: "Abhijit Chaudhari, CTO with a Bachelor’s in Industrial Electronics, brings 25+ years of Power Electronics R&D expertise. His visionary leadership aligns technology strategy with business goals. Focused on growth, his achievements include an IP55 grade AC-DC Rectifier for Defence. Abhijit thrives in a supportive, innovative environment. Beyond work, he enjoys classical music, reading, and surprises with Banjo proficiency. Abhijit Chaudhari embodies leadership, expertise, and innovation.",
  },
  {
    id: 8,
    firstName: "Aditya",
    lastName: "DHINGRA",
    role: "Business Head - Hydrogen Power Systems (Yonder H2)",
    image: Img8,
    bio: "Aditya Dhingra, a Hydrogen enthusiast and Business Head at Yonder—Ador’s Hydrogen Energy Division. With a background in Electrical Engineering and Business Management, Aditya envisions Yonder among the top 5 global electrolyzer organizations. His passion lies in impactful growth and making Yonder a pillar in future business progression. Notably, he secured the largest contract in Ador’s history. Aditya values the company’s unique blend of technological innovation, global reach, and an enjoyable work environment. Outside of work, he is a global trotter, adding adventure to his pursuits. Aditya Dhingra embodies dedication, leadership, and a vision for a sustainable future.",
  },
  {
    id: 9,
    firstName: "Shailesh",
    lastName: "BIJEGAONKAR",
    role: "Business Head - Growth Hydrogen Power Systems (Yonder H2)",
    image: Img9,
    bio: "Shailesh is a seasoned business leader in the renewable energy sector, renowned for driving business development, sales, and successful growth strategy implementation. His extensive professional background equips him to expertly address complex challenges using a strategic approach. Shailesh holds degrees in Electronics and Telecommunication, complemented by a master’s in marketing from Mumbai University.",
  },
  {
    id: 10,
    firstName: "Anwar",
    lastName: "INAMDAR",
    role: "Business Head - Defence",
    image: Img10,
    bio: "Anwar Inamdar is a seasoned professional serving as the Business Head of Defence, bringing a wealth of experience in sales and application engineering within the instrumentation, electrical, and electronic manufacturing sectors. With a proven track record in DCS/PLC field instruments and expertise in techno-commercial proposal development, Anwar demonstrates proficiency in Microsoft Word, English communication, budget proposals, and Microsoft Excel. Holding an Advanced Diploma in Digital System Design, specialized in Embedded and VLSI from ICIT (VLSI Design & Research Center), he possesses a strong foundation in cutting-edge technology.",
  },
  // {
  //   id: 11,
  //   firstName: "Archana",
  //   lastName: "DEO",
  //   role: "Head - Software Innovation",
  //   image: Img11,
  //   bio: "With 13 years of experience, Archan brings a wealth of expertise in Test Management, Agile Scrum Master, QA Management, Delivery Management, People Management, and overseeing complex deliveries. Proficient in Project Management Solutions, Change Management, and Risk Management, Archan is adept at navigating multifaceted projects.",
  // },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ot { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .ot-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
  }

  .ot-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  .ot-hero-overlay {
    position: absolute;
    inset: 0;
  }

  .ot-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }

  .ot-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px;
    font-weight: 600;
    color: #ffffff;
    line-height: 120%;
    margin-bottom: 15px;
  }

  .ot-hero-divider {
    width: 253px;
    height: 2px;
    background: #EB2019;
    border: none;
    margin-bottom: 15px;
  }

  .ot-hero-desc {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 160%;
    max-width: 501px;
    display:none;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .ot-breadcrumb {
    width: 100%;
    padding: 40px 0 0 0;
  }

  .ot-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .ot-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    display: flex;
    align-items: center;
    transition: color 0.15s;
  }

  .ot-bc-item:hover { color: #EB2019; }

  .ot-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .ot-bc-item.active {
    color: #202020;
    font-weight: 500;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .ot-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     3. TEAM GRID SECTION
  ══════════════════════════════════════════ */
  .ot-section {
    padding: 80px 0 120px 0;
  }

  .ot-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  /* ── Card ── */
  .ot-card {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;
    width: 445px;
    height: 500px;
  }

  .ot-card-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
    transition: transform 0.4s ease;
  }

  .ot-card:hover .ot-card-img {
    transform: scale(1.04);
  }

  /* Bottom gradient */
  .ot-card-gradient {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 65%;
    background: linear-gradient(
      to top,
      rgba(0,0,0,0.92) 0%,
      rgba(0,0,0,0.55) 50%,
      rgba(0,0,0,0.0) 100%
    );
    pointer-events: none;
  }

  /* Text overlay */
  .ot-card-info {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    padding: 0 30px 30px 30px;
  }

  .ot-card-firstname {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 120%;
  }

  .ot-card-lastname {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 24px;
    color: #fff;
    line-height: 120%;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  .ot-card-role {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 140%;
    margin-bottom: 20px;
    white-space: normal;
    word-break: break-word;
    max-width:208px;
  }

  .ot-know-more {
    display: inline-block;
    background: #EB2019;
    color: #ffffff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 14px 36px;
    border-radius: 10px;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
    line-height: 1;
  }

  .ot-know-more:hover { background: #c91a13; }

  /* ══════════════════════════════════════════
     4. MODAL
  ══════════════════════════════════════════ */
  .ot-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.60);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    animation: ot-fade-in 0.18s ease;
  }

  @keyframes ot-fade-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  .ot-modal {
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    max-width: 690px;
    width: 100%;
    box-shadow: 0 28px 72px rgba(0, 0, 0, 0.28);
    animation: ot-slide-up 0.22s ease;
  }

  @keyframes ot-slide-up {
    from { transform: translateY(18px); opacity: 0; }
    to   { transform: translateY(0);    opacity: 1; }
  }

  /* Top half: photo left + red namecard right */
  .ot-modal-top {
    display: flex;
    height: 300px;
    padding: 30px 30px 0 30px;
    gap: 0;
  }

  .ot-modal-photo {
    flex: 0 0 400px;
    border-radius: 14px 0px 0px 14px;
    overflow: hidden;
  }

  .ot-modal-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  .ot-modal-namecard {
    flex: 1;
    background: #EB2019;
    border-radius: 0 20px 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 24px 24px 34px 34px;
    position: relative;
  }

  .ot-modal-close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #EB2019;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    font-weight: 300;
    line-height: 1;
    font-family: sans-serif;
    transition: background 0.18s;
  }

  .ot-modal-close:hover { background: rgba(255, 255, 255, 0.38); }

  .ot-modal-fname {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .ot-modal-lname {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    line-height: 120%;
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  .ot-modal-role {
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    line-height: 120%;
  }

  /* Bio section */
  .ot-modal-bio-wrap {
    padding: 30px;
  }

  .ot-modal-bio {
    font-family: 'DM Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .ot-hero              { height: 350px; }
    .ot-hero-content      { padding: 0 32px; }
    .ot-hero-title        { font-size: 30px; margin-bottom: 16px; }
    .ot-hero-divider      { width: 200px; }
    .ot-hero-desc         { font-size: 14px; }

    .ot-breadcrumb        { padding: 28px 0 0 0; }
    .ot-breadcrumb-inner  { padding: 0 32px; }
    .ot-inner             { padding: 0 32px; }

    .ot-section           { padding: 48px 0 60px 0; }
    .ot-grid              { grid-template-columns: repeat(2, 1fr); gap: 20px; }
    .ot-card              { aspect-ratio: 1 / 1; width: auto; height: auto; }
    .ot-card-firstname    { font-size: 18px; }
    .ot-card-lastname     { font-size: 18px; }
    .ot-card-role         { font-size: 13px; margin-bottom: 14px; }
    .ot-know-more         { font-size: 13px; padding: 10px 22px; }
    .ot-modal-photo { flex: 0 0 56%;}
    .ot-modal             { max-width: 500px; }
    .ot-modal-top         { height: 240px; }
    .ot-modal-fname       { font-size: 16px; }
    .ot-modal-lname       { font-size: 18px; }
    .ot-modal-bio         { font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 560px)
  ══════════════════════════════════════════ */
  @media (max-width: 560px) {
    .ot-hero              { height: 400px; }
    .ot-hero-content      { padding: 0 16px; }
    .ot-hero-title        { font-size: 24px; margin-bottom: 15px; }
    .ot-hero-divider      { width: 180px; margin-bottom: 15px; }
    .ot-hero-desc         { font-size: 14px; max-width: 308px; }

    .ot-breadcrumb        { padding: 32px 0 0 0; }
    .ot-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .ot-bc-item           { font-size: 14px; }
    .ot-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .ot-inner             { padding: 0 16px; }

    .ot-section           { padding: 60px 0 60px 0; }
    .ot-grid              { grid-template-columns: 1fr; gap: 20px; }
    .ot-card              { width: 100%; height: 420px; }
    .ot-card-firstname    { font-size: 20px; }
    .ot-card-lastname     { font-size: 20px; }
    .ot-card-role         { font-size: 14px; margin-bottom: 16px; }
    .ot-know-more         { font-size: 14px; padding: 12px 28px; }

    /* Mobile modal — stacked layout */
    .ot-modal             { max-width: 360px; border-radius: 16px; }
    .ot-modal-top         { flex-direction: column; height: auto; padding: 0; gap: 0; }
    .ot-modal-photo       { flex: none; width: 100%; height: 220px; border-radius: 16px 16px 0 0; }
    .ot-modal-photo img   { border-radius: 16px 16px 0 0; }
    .ot-modal-namecard    { border-radius: 0; padding: 16px 20px 20px 20px; }
    .ot-modal-close       { top: -210px; right: 16px; background: rgba(0,0,0,0.30); }
    .ot-modal-fname       { font-size: 16px; }
    .ot-modal-lname       { font-size: 18px; }
    .ot-modal-role        { font-size: 11px; }
    .ot-modal-bio-wrap    { padding: 20px 20px 24px; }
    .ot-modal-bio         { font-size: 14px; line-height: 160%; }
  }
`;

export default function OurTeam() {
  const [active, setActive] = React.useState(null);

  React.useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setActive(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  React.useEffect(() => {
    document.body.style.overflow = active ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [active]);

  return (
    <div className="ot">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="ot-hero">
        <img className="ot-hero-bg" src={HeroBgImg} alt="Our Team" />
        <div className="ot-hero-overlay" />
        <div className="ot-hero-content">
          <h1 className="ot-hero-title">Our Team</h1>
          <hr className="ot-hero-divider" />
          <p className="ot-hero-desc">
            Meet the people behind Ador's mission to make roads safer for
            everyone.
          </p>
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="ot-breadcrumb" aria-label="Breadcrumb">
        <div className="ot-breadcrumb-inner">
          <a href="/" className="ot-bc-item">
            Home
          </a>
          <span className="ot-bc-sep">
            <img src={BcSepIcon} alt="" />
          </span>
          <a href="/about-us" className="ot-bc-item">
            About Us
          </a>
          <span className="ot-bc-sep">
            <img src={BcSepIcon} alt="" />
          </span>
          <span className="ot-bc-item active">Our Team</span>
        </div>
      </nav>

      {/* ══ 3. TEAM GRID ══ */}
      <section className="ot-section">
        <div className="ot-inner">
          <div className="ot-grid">
            {TEAM.map((member) => (
              <div
                className="ot-card"
                key={member.id}
                onClick={() => setActive(member)}
              >
                <img
                  className="ot-card-img"
                  src={member.image}
                  alt={`${member.firstName} ${member.lastName}`}
                />
                <div className="ot-card-gradient" />
                <div className="ot-card-info">
                  <div className="ot-card-firstname">{member.firstName}</div>
                  <div className="ot-card-lastname">{member.lastName}</div>
                  <div className="ot-card-role">{member.role}</div>
                  <button
                    className="ot-know-more"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActive(member);
                    }}
                  >
                    Know More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ 4. MODAL ══ */}
      {active && (
        <div className="ot-modal-backdrop" onClick={() => setActive(null)}>
          <div className="ot-modal" onClick={(e) => e.stopPropagation()}>
            {/* Top: photo + red namecard */}
            <div className="ot-modal-top">
              <div className="ot-modal-photo">
                <img
                  src={active.image}
                  alt={`${active.firstName} ${active.lastName}`}
                />
              </div>
              <div className="ot-modal-namecard">
                <button
                  className="ot-modal-close"
                  onClick={() => setActive(null)}
                >
                  &times;
                </button>
                <div className="ot-modal-fname">{active.firstName}</div>
                <div className="ot-modal-lname">{active.lastName}</div>
                <div className="ot-modal-role">{active.role}</div>
              </div>
            </div>

            {/* Bio */}
            <div className="ot-modal-bio-wrap">
              <p className="ot-modal-bio">{active.bio}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
